/**
 * Form Options Configuration
 * 
 * This file contains the dropdown options for various form fields.
 * Update these arrays to change the available options in the form.
 */

/**
 * Available Etappe (Stage) options
 */
export const etappeOptions = [
  'Begin catechese',
  'Eerste scrutinium',
  'Shema',
  'Tweede scrutinium',
  'Inwijding tot het gebed',
  'Traditio',
  'Retraditio',
  'Redditio',
  'Onze Vader 1',
  'Onze Vader 2',
  'Loreto',
  'Onze Vader 3',
  'Uitverkiezing 1',
  'Uitverkiezing 2',
  'Pelgrimstocht naar Israel',
  'Uitverkiezing 3',
  'Geestelijke Huwelijk',
];

/**
 * Available Bisdom (Diocese) options
 */
export const bisdomOptions = [
  'Den Bosch',
  'Groningen',
  'Haarlem-Amsterdam',
  'Roermond',
  'Rotterdam'
];

/**
 * Static fallback mapping for Bisdom -> Parochies.
 * Gemeenschappen are loaded dynamically from Firestore.
 */
export const parochiesByBisdom = {
  'Den Bosch': [
    'MAG Eindhoven, H. Leo IX',
  ],
  'Groningen': [
    'MAG Groningen, H. Agata van Catania',
  ],
  'Haarlem-Amsterdam': [
    'Alkmaar, H. Maria',
    'Amsterdam, H. Nicolaas',
    'Haarlem, H. Franciscus',
    'Hoorn, H. Mattheus',
    'MAG Almere, Sint Jan de Doper',
    'MAG Amsterdam-Uithoorn, H. Giuseppe Cottolengo & H. Felice',
    'Noord Scharwoude, Sint Jan de Doper',
    'Uithoorn, Emmaus'
  ],
  'Roermond': [
    'Maastricht, Onze Lieve Vrouw',
    'Maastricht, St. Petrus Banden',
    'MAG Kerkrade, H. Francesca Cabrini',
    'MAG Maastricht, H. Dionysius',
    'MAG Roermond, H. Pietro Crisologo',
    'Roermond, H. Thomas',
    'Sittard/Geleen, St Paulus Kerk'
  ],
  'Rotterdam': [
    'Den Haag, H. Agnes',
    'Schoonhoven, H. Bartolomeus'
  ]
};

/**
 * Helper function to get available Parochies for a selected Bisdom
 */
export const getParochiesForBisdom = (bisdom) => {
  if (!bisdom || !parochiesByBisdom[bisdom]) return [];
  return parochiesByBisdom[bisdom];
};

/**
 * Returns the next etappe in sequence based on current etappe.
 * Returns empty string when current etappe is missing, invalid, or last in sequence.
 */
export const getNextEtappe = (currentEtappe) => {
  if (!currentEtappe) return '';

  const currentIndex = etappeOptions.indexOf(currentEtappe);
  if (currentIndex === -1) return '';

  const nextIndex = currentIndex + 1;
  if (nextIndex >= etappeOptions.length) return '';

  return etappeOptions[nextIndex];
};

/**
 * Available status options for leden (members)
 */
export const lidStatusOptions = [
  'Echtpaar',
  'Man',
  'Priester',
  'Seminarist',
  'Vrouw'
];
